import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { COMPLIANCE } from "const"
import {
    StoreType,
    setCcReviewCompliancePopupMenuShow,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import Open from "./open"

const Menu = () => {
    const baseRoute = useSelector((state: StoreType) => state.ccReviewDocument.baseRoute)
    const activeFile = useSelector((state: StoreType) => state.ccReviewDocument.activeFile)
    const activeVersion = useSelector((state: StoreType) => state.ccReviewDocument.activeVersion)

    const revisionActiveList = useSelector((state: StoreType) => state.ccReviewCompliance.revisionActiveList)
    const activeItem = useSelector((state: StoreType) => state.ccReviewCompliance.active)
    const menuShow = useSelector((state: StoreType) => state.ccReviewCompliance.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.ccReviewCompliance.menuTarget)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [menuItems, setMenuItems] = useState<any[]>([])

    const hideMenu = () => {
        dispatch(setCcReviewCompliancePopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const open = (
        <PopupMenuItem
            key="open"
            onClick={() => {
                if (!activeFile || !activeVersion || !activeItem) return
                const revision = revisionActiveList[activeVersion.id] && revisionActiveList[activeVersion.id][activeItem.librarySetId]
                if (!revision) return

                Open(baseRoute, COMPLIANCE, activeFile.id, activeVersion.id, activeItem.librarySetId, revision.id, activeItem.id, dispatch)
            }}
        >
            {lang.open}
        </PopupMenuItem>
    )

    useEffect(() => {
        const menu: any[] = []
        menu.push(open)

        setMenuItems(menu)
    }, [activeItem])


    if (!menuItems.length) return null
    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {menuItems}
        </PopupMenu>
    )
}

export default Menu
